export interface BugReport {
    title: string;
    description?: string;
    files?: File[];
    pageUrl: string;
    userAgent: string;
    appVersion: string;
    os: string;
    viewport: string;
    extra?: string; // JSON string
}

export const submitBugReport = async (authToken: string, bugReport: BugReport): Promise<any | null> => {
    const formData = new FormData();
    formData.append('title', bugReport.title);
    if (bugReport.description) {
        formData.append('description', bugReport.description);
    }
    formData.append('pageUrl', bugReport.pageUrl);
    formData.append('userAgent', bugReport.userAgent);
    formData.append('appVersion', bugReport.appVersion);
    formData.append('os', bugReport.os);
    formData.append('viewport', bugReport.viewport);
    if (bugReport.extra) {
        formData.append('extra', bugReport.extra);
    }
    if (bugReport.files) {
        bugReport.files.forEach(file => {
            formData.append('files', file);
        });
    }

    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/tickets/submit-bug`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
            body: formData,
        });

        if (!response.ok) {
            console.error("Failed to submit bug report:", response.status, response.statusText);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error("Error submitting bug report:", error);
        return null;
    }
};

